module.exports = __webpack_public_path__ + "img/p2-32.7b3cd76d.png";